/**
 * Replaces positional placeholders in runtime-loaded translation strings
 * 
 * @example
 * // Translation file: "notification.minutesAgo": "{0} minutes ago"
 * replacePlaceholders("{0} minutes ago", [5]) // → "5 minutes ago"
 * 
 * @example
 * // Multiple params
 * replacePlaceholders("{0} sent {1} {2}", ["John", 3, "photos"])
 * // → "John sent 3 photos"
 * 
 * @example
 * // Reusing parameters (Rust-style)
 * replacePlaceholders("{0}, meet {1}. {1}, meet {0}", ["Alice", "Bob"])
 * // → "Alice, meet Bob. Bob, meet Alice"
 * 
 * @example
 * // Missing parameter - preserves placeholder
 * replacePlaceholders("Items: {0}, {1}, {2}", [1, 2]) // → "Items: 1, 2, {2}"
 * 
 * @example
 * // Out-of-order placeholders work correctly
 * replacePlaceholders("{2} {0} {1}", ["A", "B", "C"]) // → "C A B"
 */
export function replacePlaceholders(
  str: string,
  params: Array<string | number>
): string {
  return str.replace(/\{(\d+)\}/g, (match, indexStr) => {
    const index = Number(indexStr)
    return index in params ? String(params[index]) : match
  })
}